<template>
  <v-app id="inspire" class="fontLao">
    <div>
      <v-toolbar flat color="white">
        <v-toolbar-title>ຕິດຕາມນໍາເຂົ້າ</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="ຊອກຫາ" single-line hide-details></v-text-field>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="900">
          <!-- <v-btn slot="activator" color="primary" dark class="mb-2">ເພີ່ມ</v-btn> -->
          <v-card>
            <v-card-title>
            <span class="headline fontLao">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap class="fontLao">
                  <v-flex xs12 sm12 md12>
                    <v-radio-group v-model="selectftpro" row>
                      <v-radio label="Stock number" value="stockno"></v-radio>
                      <v-radio label="Barcode" value="bar"></v-radio>
                      <v-radio label="Product name" value="name"></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex xs12 sm12 md12 >
                    <v-autocomplete disabled
                      v-model="mdpro"
                      :items="itemspro"
                      :loading="isLoadingpro"
                      @change="chpro"
                      chips
                      clearable
                      cache-items
                      hide-no-data
                      hide-details
                      hide-selected
                      open-on-clear
                      :item-text="selectftpro"
                      item-value="id"
                      label="Stock number, Barcode, Product name"
                      solo
                    >
                      <template
                        slot="selection"
                        slot-scope="{ item, selected }"
                      >
                        <v-chip
                          :selected="selected"
                          color="primary"
                          class="white--text"
                        >
                          <v-icon left>mdi-coin</v-icon>
                          <span v-text="item.name "> </span><span v-if="item.cname" v-text="'  - ' + item.cname + ' - ( ລາຄາ ' + item.price +' )'"></span>
                        </v-chip>
                      </template>
                      <template
                        slot="item"
                        slot-scope="{ item, tile }"
                      >
                        <v-list-tile-avatar
                          color="primary"
                          class="headline font-weight-light white--text"
                        >
                          {{ item.name.charAt(0) }}
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title v-text="item.name + ' - ( ລາຄາ ' + item.price +' )'"></v-list-tile-title>
                          <v-list-tile-sub-title v-text="item.cname"></v-list-tile-sub-title>
                        </v-list-tile-content>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm12 md12> 
                    <v-select v-model="editedItem.unid" :items="unit" item-value="id" item-text="name" label="Selling Unit" disabled></v-select> 
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field  v-model="editedItem.stockno" type="text" label="Stock Number" disabled></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field disabled v-model="editedItem.itemno" type="number" min="0" label="Item no#"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field disabled v-model="editedItem.qty" type="number"  min="0" label="Qty Ordered"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field disabled v-model="editedItem.shipped" type="number" @blur="price_change" @change="price_change" @keyup="price_change" min="0" label="Shipped Ordered"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field v-model="editedItem.back" type="number" min="0" label="Back Ordered" required  @keyup="back_change"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field disabled v-model="editedItem.price" type="number" @blur="price_change" @change="price_change" @keyup="price_change" min="0" label="Unit Prcie"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field disabled v-model="editedItem.discount" type="number" @blur="price_change" @change="price_change" @keyup="price_change" min="0" label="Discount"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field :value="_P(editedItem.amount)"  type="text" label="Amount" disabled></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer >
              <v-btn color="blue darken-1" flat @click.native="close" class="fontLao">ຍົກເລີກ</v-btn>
              <v-btn color="blue darken-1" flat @click.native="save" class="fontLao">ບັນທືກ</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-data-table 
      
      :headers="headers" :items="mydata" :search="search" :rows-per-page-items=[50,100,500] class="elevation-1 fixtable">
        <template slot="items" slot-scope="props">
          <!-- <td>{{ props.item.itemno }}</td> -->
          <td>{{ props.item.order }}</td>
          <td>{{ props.item.condate }}</td>
          <td>{{ props.item.product.data.name}} <span v-if="props.item.product.data.cname" v-text="' - ' + props.item.product.data.cname"></span> </td>
          <td>{{ props.item.stockno }}</td>
          <td>{{ props.item.product.data.bar }}</td>
          <td>{{ props.item.qty }}</td>
          <td>{{ props.item.shipped }}</td>
          <td>{{ props.item.back }}</td>
          <td>{{ props.item.unit }}</td>
          <td>{{ _P(props.item.price) }}</td>
          <td>{{ _P(props.item.discount) }}</td>
          <td>{{ _P(props.item.amount) }}</td>
          <td class="text-xs-center px-0">
            <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon> 
            <!-- <v-icon small @click="deleteItem(props.item)" > delete </v-icon> -->
          </td>
        </template>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">ກົດເລີ່ມໃໝ່</v-btn>
        </template>
      </v-data-table>
    </div>
  </v-app>
</template>
<script>
import db from '@/firebase/init'
import moment from 'moment'
// moment(new Date()).format('YYYY-MM-DD')
export default {
  name:'Tracking',
  data: () => ({
    selectftpro: 'stockno',
    isLoadingpro: false,
    itemspro: [],
    unit: [],
    mdpro: null,
    searchpro: null,
    dialog: false,
    search: '',
    headers: [
      // {text: 'Item No#', value: 'itemno' ,align: 'left'},
      {text: 'Order', value: 'order' ,align: 'left'},
      {text: 'Date', value: 'condate'  ,align: 'left'},
      {text: 'Product', value: 'product'  ,align: 'left'},
      {text: 'Stock Number', value: 'stockno' ,align: 'left'},
      {text: 'Bar code', value: 'bar' ,align: 'left'},
      {text: 'Qty Ordered', value: 'qty' ,align: 'left'},
      {text: 'Qty Shipped', value: 'shipped' ,align: 'left'},
      {text: 'Back Ordered', value: 'back' ,align: 'left'},
      {text: 'Selling Unit', value: 'unit' ,align: 'left'},
      {text: 'Unit Price', value: 'price' ,align: 'left'},
      {text: 'Discount', value: 'discount' ,align: 'left'},
      {text: 'Amount', value: 'amount' ,align: 'left'},
      {text: 'ການເຄື່ອນໄຫວ', value: 'action', sortable: false,align: 'center'}
    ],
    importref:null,
    mydata: [],
    editedIndex: -1,
    editedItem: {
      itemno: 1,
      qty: 1,
      shipped: 1,
      back: 0,
      unid: null,
      stockno: null,
      product: null,
      price: 0,
      discount: 0,
      amount: 0,
      importref: null,
      categorieref:null,
      date: new Date(),
      stt:1,
      stock: 'in'
    },
    defaultItem: {
      itemno: 1,
      qty: 1,
      shipped: 1,
      back: 0,
      unid: null,
      stockno: null,
      product: null,
      price: 0,
      discount: 0,
      amount: 0,
      importref: null,
      categorieref:null,
      date: new Date(),
      stt:1,
      stock: 'in'
    }
  }),
  computed: {
    back () {
      return this.mydata.reduce((sum_, item) => sum_ + item.back, 0)
    },
    balance () {
      return this.mydata.reduce((sum_, item) => sum_ + item.amount, 0) ///+ this.editEdItem.amount
    },
    count () {
      return this.mydata.length
    },
    formTitle () {
      return this.editedIndex === -1 ? 'ເພີ່ມ' : 'ແກ້ໄຂ'
    }
  },
  watch: {
    searchpro () {
      this.initializescpd()
    },
    dialog (val) {
      if(val) {
        this.initializescpd()
      }
      val || this.close()
    }
  },
  created () {
    this.initialize()
    this.initunit()
  },
  methods: {
    price_change () {
      let amount = this.editedItem.shipped * this.editedItem.price - (this.editedItem.price * (this.editedItem.discount /100))
      this.editedItem.amount = amount.toFixed(2)
      console.log(amount.toFixed(2))
    },
    back_change () {
       if (isNaN(this.editedItem.back)||this.editedItem.back =="") return
     

      this.editedItem.qty = parseInt(this.editedItem.shipped) + parseInt(this.editedItem.back)
     // console.log(amount.toFixed(2))
    },
    _P (value) {
      let val = (value / 1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    chpro (id) {
      if (this.itemspro.length >= 1) {
        if (id != null) {
          this.editedItem.product = db.collection('products').doc(id)
          this.editedItem.product.get().then(doc => {
            if (doc.exists) {
              this.editedItem.stockno = doc.data().stockno
              if(doc.data().unid){
                this.editedItem.unid = doc.data().unid
              }
              if(doc.data().cid){
                this.editedItem.categorieref = db.collection('categories').doc(doc.data().cid)
              }
            } else {
              console.log("No such document!");
            }
          }).catch(function(error) {
            console.log("Error getting document:", error);
          })
        }
      }
    },
    initialize () {
      let tdata = []
    // this.importref = db.collection('import').doc(this.$route.params.id)
      let ref = db.collection('stock').where('back','>',0).where('stock','==','in').where("stt","==",1).get()
      .then(snapshot => {
        snapshot.forEach(async doc => {
          if (doc.exists){
            let tmpdata =doc.data()
            tmpdata.id =doc.id

            const timestamp =doc.data().date;// doc.get('date')
            tmpdata.condate = moment(timestamp.toDate()).format('DD/MM/YYYY HH:mm')
            console.log(tmpdata)

            if (doc.data().importref){
              await doc.data().importref.get().then(doc => {
                if (doc.exists) {
                  tmpdata.order = doc.data().order;
                  // tmpdata.date = doc.data().order;

                  console.log(doc.data().order)

                } else {
                console.log("No such document!");
                }
              }).catch(function(error) {
                console.log("Error getting document:", error);
              })
            }

            if (doc.data().unid) {
              await db.collection('unit').doc(doc.data().unid).get().then(doc => {
                if (doc.exists) {
                  tmpdata.unit = doc.data().name;
                } else {
                console.log("No such document!");
                }
              }).catch(function(error) {
                console.log("Error getting document:", error);
              })
            }
            if (doc.data().product.id) {
              await db.collection('products').doc(doc.data().product.id).get().then(async doc => {
                if (doc.exists) {
                  tmpdata.product.data = doc.data()                 
                  if (doc.data().cid) {
                    await db.collection('categories').doc(doc.data().cid).get().then(doc => {
                      if (doc.exists) {
                        tmpdata.product.data.cname = doc.data().name
                      } else {
                      console.log("No such document!");
                      }
                    }).catch(function(error) {
                      console.log("Error getting document:", error);
                    })
                  }
                } else {
                console.log("No such document!");
                }
              }).catch(function(error) {
                console.log("Error getting document:", error);
              })
            }
            tdata.push(tmpdata)
          }
        })
        this.mydata=tdata
      })
      .catch(err => {
        console.log('Error getting documents', err)
      })
    },
    initunit(){
      let unitdata=[];
      db.collection('unit').where("stt","==",1).get()
      .then(snapshot => {
        snapshot.forEach(doc => {
        let tmpdata =doc.data();
        tmpdata.id =doc.id;
        unitdata.push(tmpdata);
        });
        this.unit=unitdata;
      })
      .catch(err => {
        console.log('Error getting documents', err);
      });
    },
    initializescpd () {
      // Items have already been loaded
      if (this.itemspro.length > 0) return
      this.isLoadingpro = true
      let tdata=[];
      db.collection("products").where("stt","==",1).get().then(snapshot => {
        snapshot.forEach(async doc => {
          let tmpdata =doc.data();
          tmpdata.id =doc.id;
          if (doc.data().sid) {
            await db.collection("suppliers").doc(doc.data().sid).get().then(doc => {
              if (doc.exists) {
                tmpdata.sname = doc.data().name;
              }
            })
          }
          if (doc.data().cid) {
            await db.collection("categories").doc(doc.data().cid).get().then(function(doc) {
              if (doc.exists) {
                tmpdata.cname =doc.data().name;
              }
            })
          }
          tdata.push(tmpdata)
        })
        this.itemspro = tdata
      }).finally(() => (this.isLoadingpro = false))
    },
    editItem (item) {
      this.editedIndex = this.mydata.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.initializescpd()
      this.mdpro = this.editedItem.product.id
      this.dialog = true
    },
    deleteItem (item) {
       const index = this.mydata.indexOf(item)
      if ( confirm('Are you sure you want to delete this item ('+item.product.data.name+' )?')) {
        db.collection('stock').doc(item.id).update({stt:0})
        this.mydata.splice(index, 1)
      }
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.itemspro = []
        this.mdpro = null
        this.editedIndex = -1
      }, 300)
    },
    save () {
      const self = this
      if (this.editedItem.product == null) return
      if (this.editedItem.qty <= 0) return
      if (this.editedItem.price <= 0) return
      if (this.editedItem.amount <= 0) return
      if (this.editedItem.categorieref == null) return
      if (this.editedItem.shipped <= 0) return
      if (this.editedItem.back <0) return
      if (this.editedItem.back =="") return
     
      this.price_change()
      if (this.editedIndex > -1) {
        // Object.assign(this.mydata[this.editedIndex], this.editedItem)
        let id=this.editedItem.id;
        delete this.editedItem.id;
        delete this.editedItem.unit;
        this.editedItem.importref = this.importref
        this.editedItem.itemno =parseInt(this.editedItem.itemno)
        this.editedItem.qty =parseInt(this.editedItem.qty)
        this.editedItem.shipped =parseInt(this.editedItem.shipped)
        this.editedItem.back =parseInt(this.editedItem.back)
        this.editedItem.price =parseFloat(this.editedItem.price)
        this.editedItem.discount =parseInt(this.editedItem.discount)
        this.editedItem.amount =parseFloat(this.editedItem.amount)
        

        // let ref = db.collection('stock').doc(id).update(this.editedItem).then(function () {
        let ref = db.collection('stock').doc(id).update(
          {
            back:this.editedItem.back,
            qty:this.editedItem.qty 
          }
          ).then(function () {
          self.initialize()
          self.close()

          // ????
          // self.importref.update({
          //   back: self.back,
          //   balance: self.balance,
          //   items:self.count
          // })

        })
      } else {
        // this.editedItem.importref = this.importref
        // this.editedItem.itemno =parseInt(this.editedItem.itemno)
        // this.editedItem.qty =parseInt(this.editedItem.qty)
        // this.editedItem.shipped =parseInt(this.editedItem.shipped)
        // this.editedItem.back =parseInt(this.editedItem.back)
        // this.editedItem.price =parseFloat(this.editedItem.price)
        // this.editedItem.discount =parseInt(this.editedItem.discount)
        // this.editedItem.amount =parseFloat(this.editedItem.amount)
        // let ref = db.collection('stock').add(this.editedItem).then(function () {
        //   self.initialize()
        //   self.close()
        //   self.importref.update({
        //     back: self.back,
        //     balance: self.balance + self.editedItem.amount,
        //     items:self.count+1
        //   })
        // })
      }
    },
    gotopageStockIn (item) {
      this.$router.push({ name: 'StockIn', params: { proid:item.id  }})
    }
  }
}
</script>

<style>
.fontLao{
font-family: phetsarath ot !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Tracking.vue